module.exports = __webpack_public_path__ + "static/img/Oliver-Greeves.80fa91a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Oliver-Greeves.jpg
// module id = VYVK
// module chunks = 0